import { render, staticRenderFns } from "./ResultsSection.vue?vue&type=template&id=e152db44&scoped=true"
import script from "./ResultsSection.vue?vue&type=script&lang=js"
export * from "./ResultsSection.vue?vue&type=script&lang=js"
import style0 from "./ResultsSection.vue?vue&type=style&index=0&id=e152db44&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e152db44",
  null
  
)

export default component.exports